import {Component, Input} from '@angular/core';
import {FormBuilder} from '@angular/forms';
import {SubFormComponent} from '../_subform';
import {EquipmentEnums} from '@namespaces/equipment.namespace';
import {debounceTime, filter, map} from 'rxjs/operators';
import {combineLatest} from 'rxjs';
import {EquipmentStatusesProvider} from '@providers/equipment-statuses/equipment-statuses.provider';
import {EquipmentCreateOptionsService} from '@services/equipment-create-options.service';
import {FormHelperService} from '@services/form-helper.service';
import {of} from 'rxjs/internal/observable/of';

/**
 * Компонент поверки в форме карточки оборудования
 */

@Component({
    providers: [
    ],
    selector: 'apparatus-card-common',
    templateUrl: './apparatus-card-common.component.html'
})
export class ApparatusCardCommonComponent extends SubFormComponent {

    @Input() type: EquipmentEnums.Type;

    public isMaterial = false;

    public formGroupTemplate = this._fb.group({
        serial: [''],
        without_serial: [false],
        year: [''],
        status: [''],
        count: [],
        owner: [''],
        inventory_number: [''],
        commissioning_date: [''],
        is_leased: [false],
        lease_contract_number: [''],
        rent_expiry_date: [''],
        documents: this._fb.array([])
    });

    private withoutSerialValue = false;

    constructor(
        public statusListProvider: EquipmentStatusesProvider,
        private _fb: FormBuilder,
        private equipmentCreateOptions: EquipmentCreateOptionsService,
    ) {
        super();
    }

    private setNoSerial() {
        this.form.get('serial').patchValue('б/н');
    }

    /**
     * Установить как собственное оборудование
     */
    private setNotLeased() {
        this.form.get('is_leased').patchValue(false);
        this.form.get('lease_contract_number').patchValue('');
        this.form.get('rent_expiry_date').patchValue('');
    }

    afterInit() {
        this.handleMaterial();

        this.subs.push(
            this.form.get('without_serial').valueChanges.pipe(
                debounceTime(30),
                filter((value: boolean) => this.withoutSerialValue !== value )
            ).subscribe((value) => {
                this.withoutSerialValue = value;
                this.handleWithoutSerial();
            }),
            combineLatest(
                this.isMaterial ? of('') : this.form.get('serial').valueChanges,
                this.form.get('status').valueChanges,
                this.form.get('year').valueChanges,
                this.form.get('count').valueChanges,
            ).pipe(
                map((value: string[]) => value.some(v => Boolean(v)))
            ).subscribe((isFilled: boolean) => {
                /**
                 * Модель безопасно менять, если обязательные поля карточки не заполнены
                 */
                const isSafeToModelChange = !isFilled;
                this.equipmentCreateOptions.setSafeModelChangeStatus(isSafeToModelChange);
            })
        );

        this.form.get('status').updateValueAndValidity();
        this.form.get('year').updateValueAndValidity();
        this.form.get('serial').updateValueAndValidity();
        this.form.get('count').updateValueAndValidity();

        this.withoutSerialValue = this.form.get('without_serial').value;
        if (this.withoutSerialValue) {
            const serialField = this.form.get('serial');
            serialField.patchValue('б/н');
            serialField.disable();
        }
    }

    private handleWithoutSerial() {
        const checked = this.form.get('without_serial').value;
        const serialField = this.form.get('serial');

        if (checked) {
            FormHelperService.updateWithTouch(serialField, 'б/н');
            serialField.disable();
        } else {
            FormHelperService.updateWithTouch(serialField, '');
            serialField.enable();
        }
    }

    private handleMaterial() {
        this.isMaterial = this.type === EquipmentEnums.Type.material;

        if (!this.isMaterial) {
            this.form.get('count').patchValue('');
        } else {
            this.setNoSerial();
            this.setNotLeased();
        }
    }
}
